module.exports = __webpack_public_path__ + "media/application/images/img/lightbox/default-skin-b257fa9c5ac8c515ac4d77a667ce2943.svg";